import BaseRepository from "../BaseRepository";
import ReportsAPICall from "src/service/AdminAPICalls/ReportsAPICall";

class ReportsRepository extends BaseRepository {
    getReportsList = async (params) => {
        return await new ReportsAPICall().getReportsList(params);
    };
    getExportReportList = async (params) => {
        return await new ReportsAPICall().getExportReportList(params);
    }
    emailReportList = async (params) => {
        return await new ReportsAPICall().emailReportList(params);
    }
}

export default ReportsRepository;